import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import batchActions from '../../../../../actions/batch.actions';
import lookupActions from '../../../../../actions/lookup.actions';
import helper from '../../../../../utils/helper';
import qs from 'qs';
import Loading from '../../../../Helpers/Loading';
import Backend from '../../../../Layouts/Backend';
import EditBatchReportPage from './EditBatchReportPage';

class EditBatchReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      batchReport: {},
      getBatchReportError: '',
      isSubmitting: false,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.batch.batchReport !== prevState.batchReport) {
      state.batchReport = nextProps.batch.batchReport;
    }
    if (nextProps.batch.getBatchReportError !== prevState.getBatchReportError) {
      state.getBatchReportError = nextProps.batch.getBatchReportError;
    }
    if (nextProps.batch.processes !== prevState.processes) {
      state.processes = nextProps.batch.processes;
    }
    if (nextProps.batch.loading !== prevState.loading) {
      state.loading = nextProps.batch.loading;
    }
    if (nextProps.batch.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.batch.isSubmitting;
    }
    state.errors = helper.centralizeError([
      nextProps.lookup.errors,
      nextProps.batch.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  componentDidMount() {
    const { batchId } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    this.setState({ loading: true }, async () => {
      await this.props.batchActions.getSpecificBatchReport(batchId);
      await this.props.batchActions.getProcesses(batchId);
    });
    this.setState({ loading: false });
  }
  onEditBatch = (values) =>
    this.props.batchActions
      .editBatchReport(values)
      .then(() => this.props.history.push('/reports/batch-reports'))
      .catch((err) => console.log(err));

  onDeleteProcess = async (processId) =>
    await this.props.batchActions.deleteProcess(processId).then(() => {
      const { batchId } = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      this.setState({ loading: true }, async () => {
        await this.props.batchActions.getProcesses(batchId);
        await this.props.batchActions.getSpecificBatchReport(batchId);
      });
      this.setState({ loading: false });
    });
  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <div className="content-inner">
            <Loading />
          </div>
        </Backend>
      );
    }
    return (
      <EditBatchReportPage
        {...this.state}
        onEditBatch={this.onEditBatch}
        onDeleteProcess={this.onDeleteProcess}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    lookup: state.lookup,
    batch: state.batch,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    batchActions: bindActionCreators(Object.assign({}, batchActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBatchReport);
